__turbopack_context__.v({
  "alertModal": "CustomAlert-module__0PXy4q__alertModal",
  "body": "CustomAlert-module__0PXy4q__body",
  "button": "CustomAlert-module__0PXy4q__button",
  "icon": "CustomAlert-module__0PXy4q__icon",
  "message": "CustomAlert-module__0PXy4q__message",
  "messageList": "CustomAlert-module__0PXy4q__messageList",
  "overlay": "CustomAlert-module__0PXy4q__overlay",
  "root": "CustomAlert-module__0PXy4q__root",
  "title": "CustomAlert-module__0PXy4q__title",
});
